import { isEqual } from 'lodash';
import { Record } from 'immutable';
import { handleActions, combineActions } from 'redux-actions';
import {
  SUBSCRIPTION_SELECT,
  SUBSCRIPTION_PICK,
  SUBSCRIPTION_UPGRADE_RESET,
  SUBSCRIPTION_UPGRADE_SUCCEEDED,
  SUBSCRIPTION_UPGRADE_FAILED,
  SUBSCRIPTION_RENEW_RESET,
  SUBSCRIPTION_RENEW_SUCCEEDED,
  SUBSCRIPTION_RENEW_FAILED,

  subscriptionUpgradeRequested,
  subscriptionRenewRequested,
} from '../actions/subscriptions';

export const ReducerRecord = Record({
  options: global.__PRELOADED_STATE__.services,
  selectedOption: null,
  selected: null,
  upgrade: false,
  add: false,
  charged: '',
  error: null,
  fetching: false,
});

export default handleActions({
  [SUBSCRIPTION_SELECT](state, { meta, payload }) {
    return state
      .set(
        'selectedOption',
        meta.selfClosing && isEqual(state.selectedOption, payload) ? null : payload,
      );
  },
  [SUBSCRIPTION_PICK](state, { payload }) {
    return state.set('selected', payload);
  },
  [SUBSCRIPTION_UPGRADE_RESET](state) {
    return state
      .set('upgrade', false)
      .set('error', null);
  },
  [SUBSCRIPTION_RENEW_RESET](state) {
    return state
      .set('add', false)
      .set('error', null);
  },
  [combineActions(subscriptionUpgradeRequested, subscriptionRenewRequested)](state) {
    return state.set('fetching', true);
  },
  [SUBSCRIPTION_UPGRADE_SUCCEEDED](state) {
    return state
      .set('upgrade', true)
      .set('error', null)
      .set('fetching', false);
  },
  [SUBSCRIPTION_RENEW_SUCCEEDED](state) {
    return state
      .set('add', true)
      .set('error', null)
      .set('fetching', false);
  },
  [SUBSCRIPTION_UPGRADE_FAILED](state, { payload: { upgrade, error } }) {
    return state
      .set('upgrade', upgrade)
      .set('error', error)
      .set('fetching', false);
  },
  [SUBSCRIPTION_RENEW_FAILED](state, { payload: { add, error } }) {
    return state
      .set('add', add)
      .set('error', error)
      .set('fetching', false);
  },
}, new ReducerRecord());
